(function () {
  function updateProgress(track, bar) {
    var maxScroll = track.scrollWidth - track.clientWidth;
    var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    bar.style.setProperty('--progress', String(Math.min(1, Math.max(0, progress))));
  }

  function initSection(root) {
    var track = root.querySelector('[data-lop-tarjetas-track]');
    var bar = root.querySelector('[data-lop-tarjetas-progress]');
    if (!track || !bar) return;

    var onScroll = function () {
      updateProgress(track, bar);
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateProgress(track, bar);
  }

  function initAll() {
    document.querySelectorAll('[data-lop-tarjetas]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lop-tarjetas]');
    if (root) initSection(root);
  });
})();
